import { render, staticRenderFns } from "./ReminderEmailDialog.vue?vue&type=template&id=565d975e"
import script from "./ReminderEmailDialog.vue?vue&type=script&lang=js"
export * from "./ReminderEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports